import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';
export const postPatientAlert = async (patient, content) => {
  const apiURL = API_HOST + '/patient/' + patient + '/edit/alert/';
  const { token, userID } = useCurrentUser();

  try {
    const { data } = await axios.post(
      apiURL,
      {
        content: content,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + token,
          'x-dqpn-user-id': userID,
        },
      },
    );
    return data.data;
  } catch (error) {
    console.error(error);
  }
};
